/* ============================================================
   EHE LIGHT™ — Atelier Noir interactions
   ============================================================ */

const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const lerp = (a, b, t) => a + (b - a) * t;

/* ---------------- NAV ---------------- */
const nav = document.getElementById('nav');
const burger = document.getElementById('burger');
const drawer = document.getElementById('drawer');

addEventListener('scroll', () => {
  nav.classList.toggle('stuck', scrollY > 40);
}, { passive: true });

burger.addEventListener('click', () => {
  const open = drawer.classList.toggle('on');
  burger.classList.toggle('on', open);
  burger.setAttribute('aria-expanded', String(open));
  document.body.style.overflow = open ? 'hidden' : '';
});
drawer.querySelectorAll('a').forEach((a, i) => {
  a.style.transitionDelay = `${0.05 + i * 0.035}s`;
  a.addEventListener('click', () => {
    drawer.classList.remove('on');
    burger.classList.remove('on');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  });
});

/* ---------------- APRENDE MÁS DROPDOWN (touch toggle) ---------------- */
const drop = document.querySelector('.nav-drop');
if (drop) {
  const btn = drop.querySelector('.nav-drop-btn');
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = drop.classList.toggle('open');
    btn.setAttribute('aria-expanded', String(open));
  });
  addEventListener('click', (e) => {
    if (!drop.contains(e.target)) { drop.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); }
  });
}

/* ---------------- REVEAL ---------------- */
const revIO = new IntersectionObserver((es) => {
  es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); revIO.unobserve(e.target); } });
}, { rootMargin: '0px 0px -9% 0px', threshold: 0.06 });
document.querySelectorAll('[data-rev]').forEach(el => revIO.observe(el));

/* ---------------- COUNTERS ---------------- */
const fmt = n => n.toLocaleString(document.documentElement.lang||'es-ES');
const cIO = new IntersectionObserver((es) => {
  es.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target;
    cIO.unobserve(el);
    const end = parseFloat(el.dataset.count);
    const suf = el.dataset.suf || '';
    if (RM) { el.innerHTML = fmt(end) + suf; return; }
    const dur = 1500, t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const e2 = 1 - Math.pow(1 - p, 3);
      el.innerHTML = fmt(Math.round(end * e2)) + (p === 1 ? suf : '');
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });
}, { threshold: 0.4 });
document.querySelectorAll('[data-count]').forEach(el => cIO.observe(el));

/* ---------------- MARQUEE ---------------- */
const marq = document.getElementById('marq');
if (marq) marq.innerHTML += marq.innerHTML;

/* ---------------- FAQ ---------------- */
document.querySelectorAll('.q > button').forEach(btn => {
  btn.addEventListener('click', () => {
    const q = btn.parentElement;
    const open = q.classList.toggle('on');
    btn.setAttribute('aria-expanded', String(open));
  });
});

/* ---------------- CARD GLOW ---------------- */
document.querySelectorAll('[data-tilt]').forEach(card => {
  card.addEventListener('pointermove', (e) => {
    const r = card.getBoundingClientRect();
    card.style.setProperty('--mx', `${((e.clientX - r.left) / r.width) * 100}%`);
    card.style.setProperty('--my', `${((e.clientY - r.top) / r.height) * 100}%`);
  });
});

/* ---------------- PARALLAX ---------------- */
const paraEls = [...document.querySelectorAll('[data-para]')];
let ticking = false;
function parallax() {
  const vh = innerHeight;
  paraEls.forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.bottom < -200 || r.top > vh + 200) return;
    const prog = (r.top + r.height / 2 - vh / 2) / vh;
    el.style.transform = `translate3d(0,${prog * parseFloat(el.dataset.para)}px,0)`;
  });
  ticking = false;
}
if (!RM) {
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(parallax); } }, { passive: true });
  addEventListener('resize', parallax);
  parallax();
}

/* ---------------- HERO CINEMA: single video, breakpoint-aware source ---------------- */
const heroVid = document.getElementById('heroVid');
const cinema = document.getElementById('cinema');
if (heroVid) {
  const mq = matchMedia('(max-width: 900px)');
  let loaded = null;
  const mount = () => {
    const want = mq.matches ? heroVid.dataset.srcMobile : heroVid.dataset.srcDesktop;
    if (!want || want === loaded) return;
    loaded = want;
    heroVid.src = want;          // only ONE file is ever fetched
    heroVid.load();
    heroVid.play().catch(() => {});
  };
  mount();
  mq.addEventListener('change', mount);
  // iOS/Safari can defer autoplay until a gesture
  addEventListener('pointerdown', () => heroVid.play().catch(() => {}), { once: true, passive: true });
}
if (cinema && !RM) {
  addEventListener('scroll', () => {
    const y = Math.min(scrollY, innerHeight * 1.2);
    cinema.style.transform = `translate3d(0,${y * 0.28}px,0) scale(${1 + y * 0.00012})`;
  }, { passive: true });
}

/* ---------------- HERO 3D DEVICE TILT ---------------- */
const device = document.getElementById('device');
if (device && !RM) {
  let rx = 0, ry = 0, trx = 8, try_ = -14, fl = 0, tfl = 0;
  addEventListener('pointermove', (e) => {
    const nx = e.clientX / innerWidth - 0.5;
    const ny = e.clientY / innerHeight - 0.5;
    try_ = -14 + nx * 22;
    trx = 8 - ny * 16;
  }, { passive: true });
  addEventListener('scroll', () => { tfl = Math.min(scrollY * 0.06, 60); }, { passive: true });
  (function tiltLoop() {
    rx = lerp(rx, trx, 0.06);
    ry = lerp(ry, try_, 0.06);
    fl = lerp(fl, tfl, 0.08);
    device.style.transform =
      `rotateX(${rx}deg) rotateY(${ry}deg) translateY(${fl}px) translateZ(0)`;
    requestAnimationFrame(tiltLoop);
  })();
} else if (device) {
  device.style.transform = 'rotateX(6deg) rotateY(-12deg)';
}

/* ---------------- GOLD DUST CANVAS ---------------- */
(function dust() {
  const cv = document.getElementById('dust');
  if (!cv || RM) return;
  const ctx = cv.getContext('2d');
  if (!ctx) return;
  let W, H, parts = [];
  const N = innerWidth < 760 ? 42 : 90;

  function size() {
    W = cv.width = cv.offsetWidth * Math.min(devicePixelRatio, 2);
    H = cv.height = cv.offsetHeight * Math.min(devicePixelRatio, 2);
  }
  size();
  addEventListener('resize', size);

  for (let i = 0; i < N; i++) {
    parts.push({
      x: Math.random(), y: Math.random(),
      r: 0.6 + Math.random() * 1.9,
      s: 0.02 + Math.random() * 0.08,
      ph: Math.random() * Math.PI * 2,
      o: 0.15 + Math.random() * 0.5,
      gold: Math.random() > 0.3
    });
  }

  let paused = false;
  new IntersectionObserver(([e]) => { paused = !e.isIntersecting; }, { threshold: 0 }).observe(cv);

  let t = 0;
  (function frame() {
    requestAnimationFrame(frame);
    if (paused) return;
    t += 0.016;
    ctx.clearRect(0, 0, W, H);
    const dpr = Math.min(devicePixelRatio, 2);
    parts.forEach(p => {
      p.y -= p.s * 0.004;
      p.x += Math.sin(t * 0.5 + p.ph) * 0.0004;
      if (p.y < -0.05) { p.y = 1.05; p.x = Math.random(); }
      const tw = 0.55 + 0.45 * Math.sin(t * 1.4 + p.ph * 3);
      ctx.beginPath();
      ctx.arc(p.x * W, p.y * H, p.r * dpr, 0, Math.PI * 2);
      ctx.fillStyle = p.gold
        ? `rgba(217,180,91,${(p.o * tw).toFixed(3)})`
        : `rgba(190,160,255,${(p.o * tw * 0.7).toFixed(3)})`;
      ctx.fill();
    });
  })();
})();

/* ---------------- FILM STRIP DRIFT ---------------- */
const film = document.getElementById('filmTrack');
if (film && !RM) {
  let fx = 0;
  addEventListener('scroll', () => {
    const r = film.parentElement.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    // progress of section through viewport: 0 → 1
    const p = 1 - (r.bottom / (innerHeight + r.height));
    const max = film.scrollWidth - innerWidth;
    fx = Math.max(0, Math.min(max, p * max * 1.15));
    film.style.transform = `translate3d(${-fx}px,0,0)`;
  }, { passive: true });
}

/* ---------------- PROTOCOL TABS ---------------- */
const tabBtns = [...document.querySelectorAll('.tabbar [role="tab"]')];
if (tabBtns.length) {
  const panels = tabBtns.map(b => document.getElementById(b.getAttribute('aria-controls')));
  const select = (i) => {
    tabBtns.forEach((b, n) => b.setAttribute('aria-selected', String(n === i)));
    panels.forEach((p, n) => { if (p) p.hidden = n !== i; });
    // reveal any lazy-revealed content inside the newly shown panel
    panels[i]?.querySelectorAll('[data-rev]').forEach(el => el.classList.add('in'));
  };
  tabBtns.forEach((b, i) => {
    b.addEventListener('click', () => select(i));
    b.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        const next = (i + (e.key === 'ArrowRight' ? 1 : tabBtns.length - 1)) % tabBtns.length;
        tabBtns[next].focus(); select(next);
      }
    });
  });
  select(0);
}

/* ---------------- FAQ CATEGORY FILTER ---------------- */
const faqBar = document.querySelector('.faqbar');
if (faqBar) {
  const btns = [...faqBar.querySelectorAll('[role="tab"]')];
  const items = [...document.querySelectorAll('#faqList .q')];
  const empty = document.getElementById('faqEmpty');
  const apply = (cat) => {
    let shown = 0;
    items.forEach(it => {
      const cats = (it.dataset.cat || '').split(/\s+/);
      const on = cat === 'all' || cats.includes(cat);
      it.hidden = !on;
      if (on) shown++;
      if (!on) { it.classList.remove('on'); it.querySelector('button')?.setAttribute('aria-expanded','false'); }
    });
    if (empty) empty.hidden = shown > 0;
  };
  btns.forEach(b => b.addEventListener('click', () => {
    btns.forEach(x => x.setAttribute('aria-selected', String(x === b)));
    apply(b.dataset.cat);
  }));
  apply('all');
}

/* ---------------- PROSE: keep wide tables from breaking layout ---------------- */
document.querySelectorAll('.prose table').forEach(function(t){
  if (t.parentElement && t.parentElement.classList.contains('tablewrap')) return;
  var w = document.createElement('div');
  w.className = 'tablewrap';
  t.parentNode.insertBefore(w, t);
  w.appendChild(t);
});
